import { useGrowthQuery } from '@/data/useGrowthQuery';
import { growthKeys } from '@/data/queryKeys';
import { fetchMapPack } from '../api';

export function useMapPack() {
  return useGrowthQuery({
    queryKey: growthKeys.mapPack(),
    queryFn: fetchMapPack,
  });
}
